import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { EarlyAccessForm } from "./EarlyAccessForm";

const POLAROIDS = [
  { src: "/images/birthday.webp", cls: "left-[4%] top-10 -rotate-[10deg]" },
  { src: "/images/ocean.webp", cls: "right-[5%] top-16 rotate-[9deg]" },
  { src: "/images/project.webp", cls: "right-[14%] bottom-8 -rotate-[6deg]" },
  { src: "/images/letters.webp", cls: "left-[12%] bottom-10 rotate-[7deg]" },
];

export const FinalCta = () => (
  <section id="get-started" aria-labelledby="final-heading" className="relative px-5 py-24 sm:px-8 lg:py-32">
    <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[2.5rem] bg-teal-dark px-6 py-20 sm:px-12 lg:py-32">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 hidden lg:block">
        {POLAROIDS.map((p, i) => (
          <motion.div
            key={p.src}
            className={`absolute w-36 rounded-2xl bg-white p-2 shadow-2xl ${p.cls}`}
            animate={{ y: [0, -12, 0] }}
            transition={{ duration: 6 + i, repeat: Infinity, ease: "easeInOut" }}
          >
            <img src={p.src} alt="" loading="lazy" className="aspect-square w-full rounded-xl object-cover" />
          </motion.div>
        ))}
      </div>
      <div aria-hidden="true" className="absolute -bottom-24 left-1/2 h-72 w-[70%] -translate-x-1/2 rounded-full bg-gold/40 blur-3xl" />
      <div className="relative mx-auto max-w-2xl text-center">
        <Reveal>
          <h2 id="final-heading" className="font-heading text-4xl sm:text-5xl lg:text-7xl font-black leading-[0.98] tracking-[-0.03em] text-white">
            Make room for more memories.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mx-auto mt-6 max-w-md text-base md:text-lg leading-relaxed text-white/90">
            Keep the memory. Toss the clutter. Join the free early-access list and be the first to know when KeepThis! is ready.
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <div data-signup-zone className="mx-auto mt-10 max-w-xl text-left">
            <EarlyAccessForm source="final" theme="dark" />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
